export default __webpack_public_path__ + "static/media/Bracers of Swiftstriking.e06fa3fb.jpg";